import React from 'react';
import classNames from 'classnames';
import useStyles from './useStyles';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;
type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;
type ButtonOrAnchor = ButtonProps | AnchorProps;

export type Props = {
  size?: 'sm' | 'md' | 'lg';
} & ButtonOrAnchor;

function SurveyButton({ size = 'md', className, children, ...props }: Props): React.ReactElement {
  const { surveyButton } = useStyles({ size });
  if ('href' in props && props.href) {
    return (
      <a className={classNames(surveyButton, className)} {...(props as AnchorProps)}>
        {children}
      </a>
    );
  }
  return (
    <button className={classNames(surveyButton, className)} type="button" {...(props as ButtonProps)}>
      {children}
    </button>
  );
}
export default SurveyButton;
